export default __webpack_public_path__ + "static/media/logo_ro_horizontal.8b08fa07.png";